import { Typography } from "@mui/material";
import React from "react";
import SkeletonComp from "app/common/skeleton";
import "./welcomeCard.scss";

type WelcomeCardProps = {
  name: string;
  // action: () => void;
  email: string;
  showSkelton: boolean;
};

const WelcomeCard: React.FC<WelcomeCardProps> = ({
  name,
  //action,
  email,
  showSkelton,
}) => {
  const skeletonData = {
    width: 500,
    loading: showSkelton,
    height: 50,
  };

  return (
    <div className="welcomeCardContainer">
      <Typography variant="h6" component="h6">
        <SkeletonComp loadData={skeletonData}>
          <span className="nameWelcome" tabIndex={0}>
            Welcome,{name}{" "}
          </span>
        </SkeletonComp>
      </Typography>
      <div className="linesForWrapper">
        <SkeletonComp loadData={skeletonData}>
          <>
            <div className="linesForText" tabIndex={0}>
              Lines for:
            </div>
            <div
              className="linesForEmail"
              // onClick={() => {
              //   action();
              // }}
              tabIndex={0}
            >
              {email}
            </div>
          </>
        </SkeletonComp>
      </div>
    </div>
  );
};
export default WelcomeCard;
